import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import RegistrationImage from 'web/src/assets/img/registration-page-img.png'
import { useSelector } from 'react-redux'

const useStyles = makeStyles(theme => ({
    infoSection: {
        display: 'flex',
        flexDirection: 'column',
        // flexDirection: 'column-reverse',
        flex: 1,
        height: '100%',
        background: theme.lightBlueGrey,
        alignItems: 'center',
        position: 'relative',
        [theme.breakpoints.down('xs')]: {
            paddingBottom: 50
        }
    },
    infoSectionImageWrapper: {
        display: 'flex',
        justifyContent: 'center',
        maxWidth: 880,
        width: '100%',
        maxHeight: 680
    },
    infoSectionImage: {
        width: '100%',
        objectFit: 'contain',
        paddingLeft: 100,
        [theme.breakpoints.down('xs')]: {
            paddingTop: 40
        },
        [theme.breakpoints.up('sm')]: {
            height: '60vh'
        },
        [theme.breakpoints.down('md')]: {
            paddingLeft: 45
        }
    },
    infoSectionTextWrapper: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        maxWidth: 500,
        width: '100%',
        gap: 10,
        [theme.breakpoints.down('md')]: {
            padding: '0 5px'
        }
    },
    infoSectionTextHeading: {
        fontWeight: 700,
        fontSize: 33,
        color: theme.blueDark
    },
    infoSectionTextSmall: {
        paddingTop: 30,
        fontSize: '14px'
    }
}))

export const InfoSection = () => {
    const classes = useStyles()
    const { locale } = useSelector(state => state.main)

    return (
        <Box className={classes.infoSection}>
            <Box className={classes.infoSectionImageWrapper}>
                <img
                    className={classes.infoSectionImage}
                    src={RegistrationImage}
                    alt="img"
                />
            </Box>
            <Box className={classes.infoSectionTextWrapper}>
                <Typography
                    variant="body1"
                    className={classes.infoSectionTextHeading}
                >
                    {locale.register.joinAnExistingOrganization}
                </Typography>
                <Typography className={classes.infoSectionText}>
                    {locale.register.accessYourOrganization}
                </Typography>
                <Typography
                    variant="body2"
                    className={classes.infoSectionTextSmall}
                >
                    {locale.register.notSureWhoYourAdmin}
                </Typography>
            </Box>
        </Box>
    )
}
